import * as t from "io-ts"

// Single address spec
export const SingleAddress = t.type({
    Label: t.string,
    PostalCode: t.string,
})

export type ISingleAddress = t.TypeOf<typeof SingleAddress>

export interface IPlace {
    [key: string]: ISingleAddress
}

export type IPlaceID = {
    getAddressWiD: (placeId: string) => Promise<void>
    isLoading: boolean
}
